import ContainerStore from './container';

// OrderApproval Store
export default class OrderApprovalStore extends ContainerStore {}
